/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Col_FeatureInputs */

const en_fc_cmp_col_feature = /** @type {(inputs: Fc_Cmp_Col_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Fc_Cmp_Col_FeatureInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_col_feature = /** @type {((inputs?: Fc_Cmp_Col_FeatureInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Col_FeatureInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_col_feature(inputs)
});
export { fc_cmp_col_feature as "fc.cmp.col.feature" }